import { toUploadsUrl } from "./mediaUrl"

// Kept for existing callers: image URLs stay on /app/uploads/, where the
// CMS serves WebP when available (see mediaUrl.js).
const optimizedPath = text => (text ? toUploadsUrl(text) : null)

export default optimizedPath
